import userPerms from "@/services/userPermissionsToPortfolio.service";
import permissions from '@/UserPermissions/PermissionGroups';

const state = {
    userPermissions:{
        id: 0,
        contactId: 0,
        portfolioId: 0,
        permissions: 0
    }
}

const mutations = {
    SET_EDIT_CONTACT_PERMISSIONS(state, data){
        state.userPermissions = data;
    },
    SET_NEW_PERMISSIONS(state, permissions){
        state.userPermissions.permissions = permissions;
    }
}

const actions = {
    async initContactPermissionsEdit({commit, rootGetters }, id){
        const portfolioId = rootGetters.getActivePortfolio.id;
        let perms = rootGetters.getPermissionsForContact(id);

        const userPermissions = {
            id: perms?.id || 0,
            contactId: id,
            portfolioId: portfolioId,
            permissions: perms?.permissions || permissions.PermissionGroups.Guest.Permissions
        };

        commit('SET_EDIT_CONTACT_PERMISSIONS', userPermissions);
    },
    updatePermissions({commit}, permissions) {
        commit('SET_NEW_PERMISSIONS', permissions);
    },
    clearContactPermissionsEdit({commit}){
        commit('SET_EDIT_CONTACT_PERMISSIONS', {});
    },
    async publishContactPermissionsEdit({ state, dispatch }, id){
        let perms = {
            id: id,
            portfolio: {
                id: state.userPermissions.portfolioId
            },
            contact:{
                id: state.userPermissions.contactId
            },
            permissions: state.userPermissions.permissions
        }

        try{
            if(!id || id <= 0)
                await userPerms.add(perms);
            else
                await userPerms.update(id, perms);
        }
        catch (e){
            console.log(e);
            return false;
        }
        
        dispatch("updateContactPermissions", perms, { root: true });
        return true;
    }
}

const getters = {
    getEditContactPermissions(state) {
        return state.userPermissions;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}